import { Configuration as Configuration } from "../configuration";
import { CoreApi } from "../api";
import { getProcessEnv } from "./utils";
export let GENTRACE_API_KEY = "";
export let GENTRACE_BASE_PATH = "";
export let GENTRACE_BRANCH = "";
export let GENTRACE_COMMIT = "";
// @deprecated: use GENTRACE_RESULT_NAME instead
export let GENTRACE_RUN_NAME = "";
export let GENTRACE_RESULT_NAME = "";
export let globalGentraceConfig = null;
export let globalGentraceApi = null;
export let resetGlobalGentraceApi = () => {
    globalGentraceConfig = null;
};
export function init(values) {
    const { apiKey, basePath, branch, commit, runName, resultName } = values !== null && values !== void 0 ? values : {};
    if (!apiKey && !getProcessEnv("GENTRACE_API_KEY")) {
        throw new Error("Gentrace API key was provided neither by the `apiKey` param in the constructor nor by the `GENTRACE_API_KEY` env variable.");
    }
    GENTRACE_API_KEY = apiKey || getProcessEnv("GENTRACE_API_KEY");
    GENTRACE_RUN_NAME = runName || getProcessEnv("GENTRACE_RUN_NAME");
    GENTRACE_RESULT_NAME = resultName || getProcessEnv("GENTRACE_RESULT_NAME");
    if (basePath) {
        try {
            const url = new URL(basePath);
            if (url.pathname.startsWith("/api/v1")) {
            }
            else {
                throw new Error('Gentrace base path must end in "/api/v1".');
            }
        }
        catch (err) {
            throw new Error(`Invalid Gentrace base path: ${err.message}`);
        }
        GENTRACE_BASE_PATH = basePath;
    }
    globalGentraceConfig = new Configuration({
        apiKey: GENTRACE_API_KEY,
        basePath: GENTRACE_BASE_PATH,
    });
    globalGentraceApi = new CoreApi(globalGentraceConfig);
    if (branch) {
        GENTRACE_BRANCH = branch;
    }
    if (commit) {
        GENTRACE_COMMIT = commit;
    }
}
export function deinit() {
    GENTRACE_API_KEY = "";
    GENTRACE_BASE_PATH = "";
    GENTRACE_BRANCH = "";
    GENTRACE_COMMIT = "";
    globalGentraceConfig = null;
    globalGentraceApi = null;
}
